import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { getMyInfo } from '../utils/GraphUtils';
export var useLoruleAuth = function useLoruleAuth(authCallback) {
  var _useMsal = useMsal(),
      instance = _useMsal.instance,
      inProgress = _useMsal.inProgress;

  var _useState = useState({
    authenticating: true,
    account: null,
    roles: [],
    userInfo: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      authState = _useState2[0],
      setAuthState = _useState2[1];

  useEffect(function () {
    var authenticate = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var account, userInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                account = instance.getActiveAccount();

                if (!(inProgress === InteractionStatus.None)) {
                  _context.next = 13;
                  break;
                }

                if (!account) {
                  _context.next = 12;
                  break;
                }

                _context.next = 5;
                return getMyInfo(instance);

              case 5:
                userInfo = _context.sent;
                setAuthState({
                  authenticating: false,
                  account: account,
                  roles: account.idTokenClaims ? account.idTokenClaims.roles : [],
                  userInfo: userInfo
                });

                if (!authCallback) {
                  _context.next = 10;
                  break;
                }

                _context.next = 10;
                return authCallback(instance);

              case 10:
                _context.next = 13;
                break;

              case 12:
                setAuthState({
                  authenticating: false,
                  account: null,
                  roles: [],
                  userInfo: null
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function authenticate() {
        return _ref.apply(this, arguments);
      };
    }();

    authenticate();
  }, [inProgress]);
  return authState;
};